export const getBaseUrl = () => {
  return process.env.REACT_APP_API_URL + '/xa';
};

export const getPaymentUrl = () => {
  return process.env.REACT_APP_PAYMENTS_API_URL;
}

export const getReviewUrl = {
  localhost: 'https://reviews-dev.clbk.app',
  development: 'https://reviews-dev.clbk.app',
  stage: 'https://reviews-stage.clbk.app',
  production: 'https://reviews.clbk.app',
}
